import React from 'react';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import { TabsOption, Nullable } from 'global';
import { VendorOpportunity } from 'modules/vendorOpportunity';
import { CreditApplication, Document } from '@trnsact/trnsact-shared-types';
import { useDealSummaryFetch } from '../../../hooks';
import { DealSummaryTab, DealBuilderEquipmentSource } from '../../../types';
import { DealTab } from './dealTab';
import { EquipmentTab } from './equipmentTab';

interface Props {
  vo: VendorOpportunity;
  creditApp: CreditApplication;
  equipmentData: Nullable<DealBuilderEquipmentSource[]>;
  invoiceDoc: Nullable<Document>;
  refetchDocs: VoidFunction;
  refetchEquipment: VoidFunction;
}

export const DealSummaryCard = ({ vo, creditApp, equipmentData, invoiceDoc, refetchDocs, refetchEquipment }: Props) => {
  const { activeEntity, priceCalc, loading } = useDealSummaryFetch(vo?.vendorOpportunityId);

  const quote = activeEntity?.quote ?? null;

  const tabs: TabsOption<DealSummaryTab>[] = [
    {
      label: 'Deal',
      value: DealSummaryTab.Deal,
      component: (
        <DealTab
          activeEntity={activeEntity}
          quote={quote}
          loading={loading}
          priceCalc={priceCalc}
          equipmentData={equipmentData}
          invoiceDoc={invoiceDoc}
          refetchDocs={refetchDocs}
          vo={vo}
        />
      ),
    },
    {
      label: 'Equipment',
      value: DealSummaryTab.Equipment,
      component: (
        <EquipmentTab
          vo={vo}
          equipmentData={equipmentData}
          refetchEquipment={refetchEquipment}
          quote={quote}
          acceptedPaymentCriteriaSnapshot={activeEntity?.proposal?.acceptedPaymentCriteriaSnapshot ?? null}
          loading={loading}
          priceCalc={priceCalc}
          creditApp={creditApp}
        />
      ),
    },
  ];

  return (
    <CardContainer title="Deal Summary">
      <TabsContainer<DealSummaryTab> tabs={tabs} tabProps={{ variant: 'fullWidth' }} />
    </CardContainer>
  );
};
